import { render, staticRenderFns } from "./ReviewJobConfigChange.vue?vue&type=template&id=6b0b32f4&scoped=true"
import script from "./ReviewJobConfigChange.vue?vue&type=script&lang=js"
export * from "./ReviewJobConfigChange.vue?vue&type=script&lang=js"
import style0 from "./ReviewJobConfigChange.vue?vue&type=style&index=0&id=6b0b32f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0b32f4",
  null
  
)

export default component.exports